import { AbstractModelSchema } from './abstract_model_schema.js';
export const menuSchema = {
    displayName: 'menu',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        locationId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        orgId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        activeMenuTimingIds: {
            type: 'array',
            elementType: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        name: {
            type: 'shortString',
            required: true,
        },
    },
};
//# sourceMappingURL=menu_schema.js.map